<template>
  <CContainer class="pt-5" fluid>
    <Loading :active="isLoading.loadInfo || isLoading.getTableItems"></Loading>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">Payment</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/invoice-fiducia">
            <CIcon name="cil-credit-card" />
            Payment Fiducia
          </b-breadcrumb-item>
          <b-breadcrumb-item active>{{ title }}</b-breadcrumb-item>
          <b-breadcrumb-item active>Detail</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <b-card no-body>
          <b-tabs card>
            <template #tabs-start v-if="$route.params.invoiceType == 'notary' && !$helper.isEmpty(info.invoiceNoPnbp)">
              <b-nav-item @click="redirectPage()">PNBP</b-nav-item>
            </template>
            <template #tabs-end v-if="$route.params.invoiceType == 'pnbp' && !$helper.isEmpty(info.invoiceNoNotary)">
              <b-nav-item @click="redirectPage()">Notaris</b-nav-item>
            </template>
            <b-tab :title="title">
              
              <CRow>
                <CCol class="col-12 col-md-6">
                  <CCard class="custom-card">
                    <CCardBody>
                      <h5 class="custom-header">Data Invoice</h5>
                      <table class="mt-4">
                        <tr>
                          <thead>No. Invoice</thead>
                          <td class="table-semicolon"> : </td>
                          <td>{{ $route.params.invoiceType == 'pnbp' ? info.invoiceNoPnbp : info.invoiceNoNotary }}</td>
                        </tr>
                        <tr>
                          <thead>No. Receive</thead>
                          <td class="table-semicolon"> : </td>
                          <td>{{ !$helper.isEmpty(info.receiveNo) ? info.receiveNo : '-' }}</td>
                        </tr>
                        <tr>
                          <thead>Tipe Kontrak</thead>
                          <td class="table-semicolon"> : </td>
                          <td>
                            <span v-if="info.contractType == 'F'">Fiducia</span>
                            <span v-else-if="info.contractType == 'R'">Roya</span>
                            <span v-else-if="info.contractType == 'A'">APHT</span>
                            <span v-else>-</span>
                          </td>
                        </tr>
                        <tr>
                          <thead>Business Unit</thead>
                          <td class="table-semicolon"> : </td>
                          <td>{{ !$helper.isEmpty(info.businessUnit) ? info.businessUnit : '-' }}</td>
                        </tr>
                        <tr>
                          <thead>Status</thead>
                          <td class="table-semicolon"> : </td>
                          <td>
                            <span v-if="info.paymentStatus == 'U'">UNPAID</span>
                            <span v-else-if="info.paymentStatus == 'P'">PAID</span>
                            <span v-else>-</span>
                          </td>
                        </tr>
                        <tr>
                          <thead>Total Payment</thead>
                          <td class="table-semicolon"> : </td>
                          <td>Rp {{ !$helper.isEmpty(info.totalPayment) ? Number(info.totalPayment).toLocaleString('id') : '0' }}</td>
                        </tr>
                        <tr>
                          <thead>Tanggal Pengajuan</thead>
                          <td class="table-semicolon"> : </td>
                          <td>{{ $helper.showData(info.applicationDate, "shortDate") }}</td>
                        </tr>
                        <tr>
                          <thead>Tanggal Payment</thead>
                          <td class="table-semicolon"> : </td>
                          <td>{{ $helper.showData(info.paymentDate, "shortDate") }}</td>
                        </tr>
                      </table>
                    </CCardBody>
                  </CCard>
                </CCol>
                <CCol class="col-12 col-md-6">
                  <CCard class="custom-card">
                    <CCardBody>
                      <h5 class="custom-header">Data Notaris</h5>
                      <table class="mt-4">
                        <tr>
                          <thead>Nama</thead>
                          <td class="table-semicolon"> : </td>
                          <td>{{ !$helper.isEmpty(info.notaryName) ? info.notaryName : '-' }}</td>
                        </tr>
                        <tr>
                          <thead>Alamat</thead>
                          <td class="table-semicolon"> : </td>
                          <td>{{ !$helper.isEmpty(info.notaryAddress) ? info.notaryAddress : '-' }}</td>
                        </tr>
                        <tr>
                          <thead>No. NPWP</thead>
                          <td class="table-semicolon"> : </td>
                          <td>{{ !$helper.isEmpty(info.notaryNpwp) ? info.notaryNpwp : '-' }}</td>
                        </tr>
                        <tr>
                          <thead>Mobile 1</thead>
                          <td class="table-semicolon"> : </td>
                          <td>{{ !$helper.isEmpty(info.notaryMobile1) ? info.notaryMobile1 : '-' }}</td>
                        </tr>
                        <tr>
                          <thead>Mobile 2</thead>
                          <td class="table-semicolon"> : </td>
                          <td>{{ !$helper.isEmpty(info.notaryMobile2) ? info.notaryMobile2 : '-' }}</td>
                        </tr>
                        <tr>
                          <thead>Phone 1</thead>
                          <td class="table-semicolon"> : </td>
                          <td>{{ !$helper.isEmpty(info.notaryTel1) ? info.notaryTel1 : '-' }}</td>
                        </tr>
                        <tr>
                          <thead>Phone 2</thead>
                          <td class="table-semicolon"> : </td>
                          <td>{{ !$helper.isEmpty(info.notaryTel2) ? info.notaryTel2 : '-' }}</td>
                        </tr>
                      </table>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>

              <CRow>
                <CCol class="col-12">
                  <CCard class="notes-card">
                    <CCardBody>
                      <div>
                        <strong>Notes:</strong>
                      </div>
                      {{ !$helper.isEmpty(info.notes) ? info.notes : '-' }}
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>

              <CRow>
                <CCol>
                  <b-table striped hover show-empty
                    responsive="xl"
                    :items="table.items"
                    :fields="table.fields"
                    :busy="!table.isLoaded"
                    no-local-sorting no-sort-reset
                    @sort-changed="onSortChanged"
                  >
                    <template slot="empty">
                      <div v-if="!table.isLoaded" class="text-center">
                        <b-spinner label="Fetching Data..."></b-spinner>
                      </div> 
                      <div v-else class="text-center">
                        Tidak ada data
                      </div> 
                    </template>
                    <template #cell(contractNo)="row">
                      {{ !$helper.isEmpty(row.value) ? row.value : '-' }}
                    </template>
                    <template #cell(customerName)="row">
                      {{ !$helper.isEmpty(row.value) ? row.value : '-' }}
                    </template>
                    <template #cell(officeName)="row">
                      {{ !$helper.isEmpty(row.value) ? row.value : '-' }}
                    </template>
                    <template #cell(contractDate)="row">
                      {{ $helper.showData(row.value, "shortDate") }}
                    </template>
                    <template #cell(assignmentDate)="row">
                      {{ $helper.showData(row.value, "shortDate") }}
                    </template>
                    <!-- <template #cell(certificateNo)="row">
                      {{ !$helper.isEmpty(row.value) ? row.value : '-' }}
                    </template> -->
                  </b-table>
                  <CCardFooter>
                    <PageSizer :totalRows="table.totalRows" :page="table.currentPage" @page-change="onPageChange" />
                  </CCardFooter>
                </CCol>
              </CRow>

              <CRow class="mt-4" style="text-align: center;">
                <CCol>
                  <CButton class="mr-3" color="primary" @click="downloadDataInvoice" :disabled="isLoading.downloadDataInvoice">
                    <b-spinner small v-if="isLoading.downloadDataInvoice" />
                    {{ isLoading.downloadDataInvoice ? 'Sedang diproses...' : 'Download Excel Invoice' }}
                  </CButton>
                  <CButton color="primary" @click="downloadInvoice" :disabled="isLoading.downloadInvoice">
                    <b-spinner small v-if="isLoading.downloadInvoice" />
                    {{ isLoading.downloadInvoice ? 'Sedang diproses...' : 'Download PDF Invoice' }}
                  </CButton>
                </CCol>
              </CRow>

            </b-tab>
          </b-tabs>
        </b-card>
      </CCol>
    </CRow>
  </CContainer>
</template>


<script>
export default {
  name: 'InvoiceFiduciaDetail',
  data() {
    return {
      isLoading: {
        loadInfo: false,
        getTableItems: false,
        downloadDataInvoice: false,
        downloadInvoice: false,
      },

      info: {
        invoiceNoPnbp: '',
        invoiceNoNotary: '',
        contractType: '',
        businessUnit: '',
        paymentStatus: '',
        totalPayment: 0,
        applicationDate: '',
        paymentDate: '',
        receiveNo: '',
        notaryName: '',
        notaryAddress: '',
        notaryNpwp: '',
        notaryTel1: '',
        notaryTel2: '',
        notaryMobile1: '',
        notaryMobile2: ''
      },

      table: {
        isLoaded: false,
        fields: [
          {key: "contractNo", label: "No. Kontrak", sortable: true},
          {key: "customerName", label: "Nama Customer", sortable: true},
          {key: "officeName", label: "Office", sortable: true, class: "custom-column-payment-detail-office"},
          {key: "contractDate", label: "Tanggal Kontrak", sortable: true},
          {key: "assignmentDate", label: "Tanggal Assign", sortable: true},
          // {key: "certificateNo", label: "No. Sertifikat", sortable: true, class: "custom-column-payment-detail-certificate"},
        ],

        items: [],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },

      title: 'Notaris',
    }
  },
  methods: {
    redirectPage() {
      let contractId = this.$route.params.contractId
      let invoiceType = this.$route.params.invoiceType == 'pnbp' ? 'notary' : 'pnbp'
      
      this.$router.push({ name: 'Invoice Fiducia Detail', params: { invoiceType: invoiceType, contractId: contractId} })
      
      this.title = this.$route.params.invoiceType == 'pnbp' ? 'PNBP' : 'Notaris'
      this.loadInfo()
      this.getTableItems()
    },

    downloadDataInvoice() {
      this.isLoading.downloadDataInvoice = true
      let getUrl = "/excel/getDetailInvoiceByte"
      let params = {}
      params['contractId'] = this.$route.params.contractId
      params['contractType'] = 'F'
      params['invoiceType'] = this.$route.params.invoiceType
      this.$axios.get(getUrl, {
        // necessary to avoid encoding returned bytes
        params: params, 
        responseType: 'blob',
        timeout: 300000
      }).then(response => {
        if(response.status == 200){
          // create file Blob and download according to extension
          let blob=new Blob([response.data], {type: "application/octet-stream"})
          let link=document.createElement('a')
          link.href=window.URL.createObjectURL(blob)
          if (this.$route.params.invoiceType == 'pnbp') {
            link.download= "Invoice_" + this.$route.params.invoiceType + "_" + this.info.invoiceNoPnbp + "-" + Date.now() + ".xlsx"
          } 
          else{
            link.download= "Invoice_" + this.$route.params.invoiceType + "_" + this.info.invoiceNoNotary + "-" + Date.now() + ".xlsx"
          }
          link.click();
        }
        else{
          this.$helper.toastError(this, "Download Data Invoice Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Download Data Invoice Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Download Data Invoice Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading.downloadDataInvoice = false
      })
    },

    // downloadInvoice() {
    //   this.isLoading.downloadInvoice = true
    //   let postUrl = "/payment/createInvoiceFile"
    //   let data = new FormData()
    //   if (this.$route.params.invoiceType == 'pnbp') {
    //     data.set('invoiceNo', this.info.invoiceNoPnbp)
    //   } else{
    //     data.set('invoiceNo', this.info.invoiceNoNotary)
    //   }
    //   this.$axios.post(postUrl, data).then(response => {
    //     if(response.status == 200){
    //       window.open(response.data.data, "_blank")
    //       window.focus()
    //       this.$helper.toastSuccess(this, "Download Invoice Sukses! " + (response.data.reason ? response.data.reason : ""))
    //     } else{
    //       this.$helper.toastError(this, "Download Invoice Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
    //     }
    //   })
    //   .catch(error => {
    //     if(!this.$helper.isEmpty(error.response)){
    //       this.$helper.toastError(this, "Download Invoice Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
    //     }
    //     else{
    //       this.$helper.toastError(this, "Download Invoice Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //     }
    //   })
    //   .finally(() => {
    //     this.isLoading.downloadInvoice = false
    //   })
    // },
    downloadInvoice() {
      this.isLoading.downloadInvoice = true
      let postUrl = "/payment/createInvoiceByte"
      let data = new FormData()
      if (this.$route.params.invoiceType == 'pnbp') {
        data.set('invoiceNo', this.info.invoiceNoPnbp)
      } else{
        data.set('invoiceNo', this.info.invoiceNoNotary)
      }
      this.$axios.post(postUrl, data, {
          // necessary to avoid encoding returned bytes
          responseType: 'blob',
          timeout: 300000
        }).then(response => {
        if(response.status == 200){
          // create file Blob and download according to extension
          let blob=new Blob([response.data], {type: "application/octet-stream"})
          let link=document.createElement('a')
          link.href=window.URL.createObjectURL(blob)
          if (this.$route.params.invoiceType == 'pnbp') {
            link.download= "Invoice_" + this.info.invoiceNoPnbp + "-" + Date.now() + ".pdf"
          } else{
            link.download= "Invoice_" + this.info.invoiceNoNotary + "-" + Date.now() + ".pdf"
          }
          link.click();
        } 
        else{
          this.$helper.toastError(this, "Download Invoice Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Download Invoice Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Download Invoice Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading.downloadInvoice = false
      })
    },

    onPageChange(newPage) {
      this.getTableItems(newPage)
    },

    onSortChanged(ctx) {
      this.table.sort.by = ctx.sortBy
      this.table.sort.desc = ctx.sortDesc
      this.getTableItems(this.table.currentPage)
    },

    async loadInfo() {
      this.isLoading.loadInfo = true
      let getUrl = "/payment/getOneInvoiceByNo"
      let params = {}
      params['contractId'] = this.$route.params.contractId
      params['contractType'] = 'F'
      params['invoiceType'] = this.$route.params.invoiceType
      return await this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.info = response.data.data
          return true
        } else{
          this.$helper.toastError(this, "Load Informasi Invoice Gagal! " + (response.data.reason ? response.data.reason : ""))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Informasi Invoice Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Informasi Invoice Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading.loadInfo = false
      })
    },

    getTableItems(page = 1) {
      this.table.isLoaded = false
      this.isLoading.getTableItems = true
      this.table.items = []
      if(isNaN(page)) {
        this.table.currentPage = 1
      }
      else {
        this.table.currentPage = page
      }
      // URL builder
      let getUrl = "/payment/getAllContractByInvoice"
      let params = this.$helper.getBasePagedQuery(this.table.currentPage - 1, this.table.perPage)
      params['invoiceType'] = this.$route.params.invoiceType
      params['contractType'] = this.info.contractType
      if (this.$route.params.invoiceType == 'pnbp') {
        params['invoiceNo'] = this.info.invoiceNoPnbp
      } else{
        params['invoiceNo'] = this.info.invoiceNoNotary
      }
      if(this.table.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.table.sort, params)
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.table.items = response.data.data.data
          this.table.totalRows = response.data.data.totalElements
          this.table.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
        this.isLoading.getTableItems = false
      })
    },
  },
  computed: {
  },
  async created(){
    this.title = this.$route.params.invoiceType == 'pnbp' ? 'PNBP' : 'Notaris'
    let success = await this.loadInfo()
    if (success) this.getTableItems()
  }
}
</script>

<style scoped>
.card-header .nav-item a {
  color: white;
}
.card.custom-card {
  min-height: 300px !important;
}
.card.notes-card {
  border-bottom: 5px solid hsl(210, 3%, 85%) !important;
}
thead {
  font-weight: 500;
}
.table-semicolon {
  min-width: 30px; 
  text-align: center;
}
</style>
